import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router';
import { Spin } from 'antd';
import { Role } from '@/features/auth/auth.def.ts';
import { ProtectedRoutes } from '@/router/ProtectedRoutes.tsx';

const DataMaskingRunsPage = lazy(() => import('./data-masking-runs-page.tsx'));

/** UX gate for the read-only viewer; API authorization remains the security boundary. */
export const dataMaskingRoutes: RouteObject = {
  path: 'operations/data-masking',
  element: (
    <ProtectedRoutes
      allowRoles={[Role.Developer]}
      requiredPermissions={[
        { moduleName: 'investor-management', functionName: 'read-data-masking-run-status' },
      ]}
    />
  ),
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Spin />}>
          <DataMaskingRunsPage />
        </Suspense>
      ),
    },
  ],
};
